module.exports = __webpack_public_path__ + "static/slezska-uni-625d31d3ba33cc74bd6d30c8dc718020.png";